import { createSelector } from "reselect";
import { groupBy } from "../../../utils/groupBy";
import { RootState } from "../../rootReducer";

export const selectDocumentHistory = createSelector(
  [(store: RootState) => store.documentSignerShow.history],
  (data = []) =>
    groupBy(
      (data || []).map((item) => ({ ...item, createdAtDate: item.createdAtLegible?.date })),
      "createdAtDate"
    )
);
